import { Box, BoxProps } from '@chakra-ui/react';
import { useNProgress } from '@tanem/react-nprogress';
import { rem } from 'polished';
import { gradients } from '../../theme/colors';

export interface Props extends BoxProps {
  isAnimating?: boolean;
  background?: string;
}

export const LoadingBar = ({ isAnimating, background = gradients.sunnySky, ...props }: Props) => {
  const { animationDuration, isFinished, progress } = useNProgress({
    isAnimating,
  });

  if (isFinished) return null;

  return (
    <Box pos="relative" h={rem(16)} rounded={rem(20)} w="100%" bg="gray.4" {...props}>
      <Box
        h="100%"
        rounded={rem(20)}
        w={`${progress * 100}%`}
        transition={`width ${animationDuration}ms linear`}
        sx={{
          mask: 'linear-gradient(#fff 0 0)',
          WebkitMask: 'linear-gradient(#fff 0 0)',
        }}
        _before={{
          content: '""',
          pos: 'absolute',
          inset: 0,
          background,
        }}
      />
    </Box>
  );
};
